import React, { useState } from "react";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Button } from "@mui/material";
import axiosInstance from "../../server/axios";

const UserList = (userdata) => {
  const users = userdata.data.users;
  const grade = userdata.data.grade;

  const checkError = (codeNumber,errordata) => {
    return codeNumber === 200 ? alert("Completed") : alert(`Error! code : ${errordata.status}`)
  }
  async function changedGrade(_userid,_grade){
    const changedGrade = await axiosInstance.patch(`/users/${_userid}`,{grade:_grade});
    checkError(changedGrade.status,changedGrade)
  }
  async function delUser(_userid){
    const deleteUser = await axiosInstance.delete(`/users/${_userid}`);
    checkError(deleteUser.status,deleteUser)
  };
  async function getUser(){
    const Userlist = await axiosInstance.get('/users/all');
    userdata.update({users:Userlist.data.userlist,grade:Userlist.data.gradelist});
  };
  const handleGrade = (event) => {
    if(window.confirm(`User id [${event.target.name}] change grade [${event.target.value}] ?`)){
      changedGrade(event.target.name,event.target.value);
      getUser();
    }else{
      return false;
    }
  };
  const deleteUser = (userid) => {
    if(window.confirm(`Do you want to delete [${userid}] ?`)){
      delUser(userid);
      getUser();
    }else{
      return false;
    }
  }

  const User = ({users}) => {
    return (
      <tr>
        <td>{users.i + 1}</td>
        <td>{users.data.username}</td>
        <td>{users.data.userid}</td>
        <td>{users.data.createdat.substr(0,10)}</td>
{   /*     <td>{users.data.updatedat.substr(0,10)}</td>    */}
        <td>
        {users.data.username.length === 0 ?
          <></>
          :
          <Select
            value={users.data.grade}
            name={users.data.userid}
            onChange={handleGrade}
          >{grade.map((val)=>
            <MenuItem key={users.data.username+val} value={val}>{val}</MenuItem>
          )}
          </Select>
        }
        </td>
        <td>Freeze</td>
        <td>
        {users.data.username.length === 0?
          <Button variant="contained" color="success" size="big" disabled>삭제</Button>
          :
          <Button variant="contained" color="success" size="big" onClick={()=>deleteUser(users.data.userid)} >삭제</Button>
        }
        </td>
      </tr>
    )
  }
  return (
    <table className="company_main">
      <thead>
        <tr>
          <th>No</th>
          <th>UserName</th>
          <th>UserID</th>
          <th>createdat</th>
   {/*       <th>Last<br></br>Visitedat</th>  */}
          <th>grade<br></br>change</th>
          <th>freeze</th>
          <th>delete</th>
        </tr>
      </thead>
      <tbody>
      {users.map( (data,i) => 
        <User key={data.userid} users={{data,i}}/> 
      )}
      </tbody>
    </table>
      )
}
export default UserList;